class Controller {
  constructor($injector, $stateParams, Sections) {
    this.$injector = $injector;
    this.Events = this.$injector.get("Events");
    this.$stateParams = $stateParams;

    this.activeParams = this.$stateParams;
    this.sections = Sections.settingsSections;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;

    this.addItemEvent = this.Events.getAddEvent("event");
    this.filterEvent = this.Events.getFilterEvent("event");
    this.paginateEvent = this.Events.getPaginateEvent("event");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/events/events.controller.js